import { useAuth0 } from '@auth0/auth0-react'
import type { ReactNode } from 'react'

function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (!isAuthenticated) {
    void loginWithRedirect({
      appState: { returnTo: window.location.pathname },
    })
    return null
  }

  return <>{children}</>
}

export { ProtectedRoute }
